import { IntlShape } from "react-intl";
import { orderBy } from "lodash-es";

import { bannerStatusType2 } from "@app/api/core/banner/banner";
import { GetBannersExtendedBannerTypeEnum } from "@app/api/generated";

export const bannerStatusSelectValues: { id: number; name: string }[] = [
  { id: 0, name: "global.banner.status.all" },
  { id: 1, name: "global.banner.status.invisible" },
  { id: 2, name: "global.banner.status.visible" },
  { id: 3, name: "global.banner.status.almostVisible" }
];

export const getTranslatedBannerStatus = (intl: IntlShape): bannerStatusType2[] =>
  bannerStatusSelectValues.map((bannerStatus) => ({
    id: bannerStatus.id,
    name: intl.formatMessage({ id: bannerStatus.name })
  }));

export const getTranslatedBannerTypes = (intl: IntlShape): { id: string; name: string }[] =>
  orderBy(
    Object.keys(GetBannersExtendedBannerTypeEnum).map((key) => ({
      id: key,
      name: getTranslatedBannerType(intl, key as GetBannersExtendedBannerTypeEnum)
    })),
    (e) => (e.id === GetBannersExtendedBannerTypeEnum.OVERVIEW ? 0 : 1)
  );

export const getTranslatedBannerType = (intl: IntlShape, type?: GetBannersExtendedBannerTypeEnum): string => {
  if (!type) return intl.formatMessage({ id: "banner.type.OVERVIEW" });

  return intl.formatMessage({ id: `banner.type.${type}` });
};
